/* eslint-disable */
import React from "react";
import { Grid, Box } from "@material-ui/core";
import "./EventItem.scss";
import { EventItemTitle } from "./EventItemTitle";
import { EventItemDescription } from "./EventItemDescription";
import { EventItemProperties } from "./EventItemProperties";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ELearningListData } from "../../../../../models/elearning";

interface EventItemProps {
  event: ELearningListData;
  preview?: boolean;
  favorite?: boolean;
}

export const EventItem: React.FC<EventItemProps> = (props) => {
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box p={small ? 1 : 0}>
      <Grid container spacing={small ? 0 : 4} className="event-item">
        <Grid item xs={12} md={9} lg={9}>
          <EventItemTitle
            event={props.event}
            preview={props.preview}
            favorite={props.favorite}
          />
          <EventItemDescription description={props.event.description} />
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <EventItemProperties event={props.event} preview={props.preview} />
        </Grid>
      </Grid>
    </Box>
  );
};
